import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gradient-hero text-primary-foreground">
      <Helmet>
        <title>{t("legal.terms.metaTitle")}</title>
        <meta name="description" content={t("legal.terms.metaDesc")} />
        <link rel="canonical" href="https://tipomatic.app/terms" />
        <meta property="og:title" content={t("legal.terms.metaTitle")} />
        <meta property="og:description" content={t("legal.terms.metaDesc")} />
        <meta property="og:url" content="https://tipomatic.app/terms" />
      </Helmet>

      <header className="container mx-auto px-4 py-5 flex items-center justify-between">
        <div className="flex items-center gap-2 font-bold text-lg">
          <img src="/icon-512.png?v=2" alt="Tipomatic" className="h-8 w-8 rounded-lg object-cover" />
          Tipomatic
        </div>
        <Button asChild variant="ghost" className="text-pitch-cream hover:bg-white/10 hover:text-pitch-cream">
          <Link to="/"><ChevronLeft className="mr-1 h-4 w-4" /> {t("legal.back")}</Link>
        </Button>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-8">{t("legal.terms.title")}</h1>

        <div className="space-y-8 text-pitch-cream/80 text-sm leading-relaxed">
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <section key={n}>
              <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t(`legal.terms.s${n}Title`)}</h2>
              <p>{t(`legal.terms.s${n}Body`)}</p>
            </section>
          ))}

          <section>
            <h2 className="text-lg font-semibold text-pitch-cream mb-2">{t("legal.terms.s7Title")}</h2>
            <p>
              {t("legal.terms.s7BodyPrefix")}
              <a href="mailto:notify@tipomatic.app" className="text-primary underline">notify@tipomatic.app</a>.
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-pitch py-8 text-center text-pitch-cream/40 text-sm">
        {t("legal.footer")}
      </footer>
    </div>
  );
}
